/**
 * Ficha técnica = similitud con el mensaje de pre-registro.
 * Preferir flag del API (busca en historial). Fallback: preview del listado.
 */
export function mensajeEsFichaTecnica (msg) {
  const t = String(msg || '')
  if (!t || t.length < 40) return false

  if (/as[ií]\s+qued[oó]\s+tu\s+pre\s*registro/i.test(t)) return true

  const tieneFolioBeca = /folio\s+de\s+beca/i.test(t)
  const tieneFelicidades = /felicidades/i.test(t)
  const tieneNombre = /\*?\s*Nombre\s*:?\s*\*?/i.test(t)
  const tieneEdad = /\*?\s*Edad\s*:?\s*\*?/i.test(t)
  const tieneModalidadOPlantel = /\*?\s*Modalidad\s*:?\s*\*?/i.test(t)
    || /\*?\s*Plantel\s*:?\s*\*?/i.test(t)
  const tieneHorario = /\*?\s*Horario\s*:?\s*\*?/i.test(t)

  if (tieneFolioBeca && tieneFelicidades && tieneNombre) return true
  if (tieneNombre && tieneEdad && tieneModalidadOPlantel && (tieneHorario || tieneFolioBeca)) return true
  if (/confirmando\s+tus\s+datos/i.test(t) && tieneNombre && tieneEdad) return true

  return false
}

export function chatTieneFichaTecnica (chat) {
  if (!chat || typeof chat !== 'object') return false
  if (chat.ficha_tecnica_enviada === true || chat.ficha_tecnica_enviada === 1) return true
  if (chat.ficha_tecnica_enviada === false || chat.ficha_tecnica_enviada === 0) return false
  return mensajeEsFichaTecnica(chat.mensaje || chat.Body || chat.body)
}
